export const adaptEstudio = (estudio) => {
    const {nombre, file} = estudio;
    return {
        contentType: file?.contentType,
        archivo: file?.archivo,
        extension: file?.extension,
        titulo: nombre,
    }
}

export const adaptEstudiosArray = (estudiosAdjuntos) => {
    return (estudiosAdjuntos.map((estudio) => { return adaptEstudio(estudio) }))
}